import React, { useCallback, useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useMount, useUnmount, useUpdateEffect, usePrevious } from 'react-use';
import { is, Map } from 'immutable';
import { useLocation, useHistory, Link } from 'react-router-dom';

import {
  getConvIdsSelector,
  orderOfConvSelector,
  getConvByIdSelector,
  isActiveSelector,
  currentConvIdSelector,
  currentOrderIdSelector,
  convRefreshKeySelector
} from '@/models/conversations/selectors';
import {
  navToConversation,
  togglePinned,
  fetchConvs, navToOrderConv, queryConvStats, resetConvs,
  markRead
} from '@/models/conversations/actions';
import {
  closeMessageOrder,
  saveOrderConfirmFee
} from '@/models/conversations/services';
import {
  getOrder,
  showAssignDialog,
  showAssignWorkerDialog,
  ordersFetched,
  showCreateOrderDialog,
  taskFetched
} from '@/models/orders/actions';
import { getCurrentUser } from '@/models/user/selectors';
import { fetchGroupManager } from '@/models/managers/actions';
import { fetchStaffConvs } from '@/models/tenants/actions';
import { findById } from '@/models/orders/selectors';

import cn from 'classnames';
import dayjs from 'dayjs';
import { Badge, Icon, Spin, Dropdown, Menu, Avatar, Tooltip, Tag, Button, Popover, Popconfirm, Modal, Form, Input, message } from 'antd';
import * as utils from '@/utils';
import StatusBadge from '@/components/StatusBadge';
import BlinkingBadge from '@/components/BlinkingBadge';
import TagFlag from '@/components/TagFlag';
import styles from './style.module.less';
import regions, { simplifyName } from '@/utils/regions';
import MessageList from '../MessageBox/List';
import EditorBox from '../MessageBox/Editor';
import Member from '../MessageBox/Member';
import * as taskHallServices from '@/models/taskHall/services';
import { orderStatus } from '@/models/orders/defines/constants';
import TenantStatusBadge from '../TenantStatusBadge';

const isTenantMode = process.env.APP_MODE === 'tenant';
const isManagerMode = process.env.APP_MODE === 'manager';
const APP_MODE = process.env.APP_MODE === 'tenant' ? "staff" : "manager"
const twoHourAgo = Date.now() - 1000 * 60 * 60 * 2;
function simplifyLogoName(name) {
  if (!name) return ''
  var shortName = name;
  var provinces = regions.provinces;
  for (var idx in provinces) {
    var pro = provinces[idx]
    if (shortName.indexOf(pro.name) != -1) {
      shortName = name.replace(pro.name, '')
    }
    var proShort = simplifyName(pro.name)
    if (shortName.indexOf(proShort) != -1) {
      shortName = shortName.replace(proShort, '')
    }
  }
  return shortName.substr(0, Math.min(4, shortName.length))
}

/**

 * @param {String} type 组件引用类型 [processed（已处理）| chatview（展开聊天顶部）| search（搜索）]
 * @param {Function} change 点击某一个
 * @param {Function} onChat 展开聊天
 * @param {Function} resetConvList
 */
function ConversationItem(props) {
  const { type, convId, customConv, change, onChat, resetConvList, resetTaskHall } = props

  const dispatch = useDispatch();
  const conv = customConv || useSelector(getConvByIdSelector(convId));
  // const order = useSelector(orderOfConvSelector(convId), is);
  const order = useSelector(findById(conv?.get('order_id')));
  const isActive = useSelector(isActiveSelector(convId));
  const prevActiveState = usePrevious(isActive);

  const clickHandler = useCallback(() => {
    !isActive && dispatch(navToConversation(convId, order?.get('_id')));
    typeof change === 'function' && change({ convId, orderId: order?.get('_id') })
  }, [convId, order, isActive]);

  const togglePinnedHandler = useCallback(
    (event) => {
      event.preventDefault();
      dispatch(togglePinned(convId));
    },
    [convId]
  );

  const latest_ts = dayjs(conv?.get('latest_ts'));
  const latestTs = latest_ts.isSame(dayjs(), 'day')
    ? latest_ts.format('HH:mm')
    : latest_ts.fromNow();
  // const latestTs = latest_ts.format('HH:mm:ss')

  useUpdateEffect(() => {
    // 异步更新 当前order的信息
    if (isActive && prevActiveState !== isActive) {
      dispatch(getOrder(order?.get('_id')));
    }
  });

  useMount(() => {
    if (isActive) {
      dispatch(getOrder(order?.get('_id')));
    }
  });

  const timeout =
    order?.get('worker') &&
    !order?.get('service_time') &&
    order?.get('worker_assigned_at') &&
    new Date(order?.get('worker_assigned_at')).getTime() < twoHourAgo;

  // TODO: currentId有变化的时候需要将滚动条移植相应位置
  const status = utils.getStatus(order);

  const ignoreOrders = (orderId) => {
    taskHallServices.setIgnore({
      source: 2,
      orderId: orderId,
    }).then(result => {
      typeof resetConvList == 'function' && resetConvList()
      message.success('操作成功')

    }).catch((err) => {
      message.error(err.message || '操作失败，请刷新重试');
    })
      .finally(() => {
      });
  }

  const menu = (
    <Menu className={styles.dropDown}>
      {!isTenantMode && (
        <Menu.Item key="0">
          <span onClick={togglePinnedHandler} className={styles.eventArea}>
            {conv?.get('is_pinned') ? '取消置顶' : '置顶'}
          </span>
        </Menu.Item>
      )}
    </Menu>
  );
  const BottomRightMenu = () => {
    return (
      <div className={styles.bottomRightMenu} onClick={e => e.stopPropagation()}>

        {/* {order.get('order_tip_op') == 2 && */}
        <Button type="primary" size="small"
          onClick={() => {
            typeof onProcessedSuccess == 'function' && onProcessedSuccess()
            ignoreOrders(order?.get("_id"))
          }}
        >忽略</Button>
        {/* } */}

        {!['processed', 'search'].includes(type) && <Button type="link"
          size="small"
          onClick={() => {
            if (!type) {
              dispatch(markRead(convId))
              onChat(convId, order?.get('_id'))
              clickHandler()
            } else {
              onChat(null, null)
            }
          }}>
          <Badge count={conv?.get('unread_count')} style={{ marginRight: 5, transform: 'scale(0.8)' }}></Badge> 展开聊天 <Icon type="caret-down" />
        </Button>}
      </div>
    )
  }
  return (
    <div className={cn(styles.conversationItem,
      order?.get('order_tip_op') == 1 && styles.operate,
      order?.get('order_tip_op') == 2 && styles.notice,
      isActive && styles.active)}
      onClick={clickHandler}
    >
      {order?.get('order_tip_op') == 2 ? <div className={cn(styles.itemstatus, styles.blue)}
      >
        提醒消息
      </div> : <>
        {(order?.get('is_urgent')
          // || timeout
        ) && (<div className={styles.itemstatus}>
          {order?.get('is_urgent') ? '急单' : ''}
          {/* {timeout ? '超时' : ''} */}
        </div>)}
      </>}

      <div className={styles.workorder}>
        <div className={styles.tags}>
          <StatusBadge style={{ background: '#4D4D4D' }}>
            {latestTs}
          </StatusBadge>
          {conv?.get('is_new') > 0 && <StatusBadge style={{ background: '#FF3232' }}>
            新工单
          </StatusBadge>}
          {Object.keys(status).length > 0 && <StatusBadge style={status.style}>
            {status.text}{(order?.get('is_guaqi') && [
              orderStatus.PROCESSING_WAIT_APPOINTMENT,
              orderStatus.PROCESSING_WAIT_SERVICE,
              orderStatus.WORKER_LOCATION_CHECKED,
            ].includes(order?.get('status_code'))) ? ' | 挂起' : ''}
          </StatusBadge>}
          {/* {(order.get('tags') || []).map((tag) => {
            const { text, ...style } = utils.getTag(tag);
            return (
              <StatusBadge key={tag} style={style}>
                {text}
              </StatusBadge>
            );
          })} */}

          {order?.get('payer_type') == 2 && <StatusBadge style={{
            color: 'red',
            fontSize: '16px',
            fontWeight: 'bold',
            background: 'transparent'
          }}>
            保外
          </StatusBadge>}

          {!order?.get('is_retail') && <TenantStatusBadge order={order?.toJS()} />}
          <TagFlag itemId={conv?.get('_id')} flag={conv?.get('tag_flag')} change={() => {
            resetConvList()
            dispatch(getOrder(order?.get('_id')))
          }} />
          {order?.getIn(['tenant', 'quotationStart']) > 0 &&
            order?.getIn(['tenant', 'quotationEnd']) > 0 &&
            <div style={{ float: 'right' }}>
              合作价：{order?.getIn(['tenant', 'quotationStart'])} - {order?.getIn(['tenant', 'quotationEnd'])}
            </div>
          }
        </div>
        {order?.get('is_retail') ? <div className={styles.workorderinfo} >
          <div className={styles.infoitem}>
            <div className={styles.desclist}>
              <div className={styles.descitem}>
                服务内容：{order?.get('order_name') || ''}
              </div>
            </div>
          </div>
          <div className={styles.infoitem}>
            <div className={styles.desclist}>
              <div className={styles.descitem}>
                订单编号：{order?.get('order_no') || ''}
              </div>
            </div>
          </div>
        </div> :
          <div className={styles.workorderinfo}>
            <div className={styles.infoitem}>
              {
                process.env.APP_MODE === 'manager'
                &&
                (
                  order?.get('tenant')
                    ?
                    (
                      <div className={styles.logo}>
                        {/* <span className={styles.tit}>企业</span> */}
                        <Tooltip title={order?.getIn(['tenant', 'short_name'])}>
                          {order?.getIn(['tenant', 'logo']) ? (
                            <Avatar
                              size={42}
                              src={order?.getIn(['tenant', 'logo'])}
                            />) :
                            (
                              <Avatar shape="square" size={42}
                                style={{ backgroundColor: '#87d068' }}>{simplifyLogoName(order?.getIn(['tenant', 'short_name']))}</Avatar>)
                          }
                        </Tooltip>
                      </div>
                    )
                    :
                    (
                      <div className={styles.logo}>
                        {/* xxx 先生 */}
                        {/* <Avatar size="small" src={order.tenant?.logo} /> */}
                        {/* <span className={styles.tit}>下单人</span> */}
                      </div>
                    )
                )
              }
              <div className={styles.desclist}>
                <div className={styles.descitem}>
                  {order?.getIn(['tenant', 'short_name'])}
                  {(order?.getIn(['tenant', 'short_name']) && order?.getIn(['tenant', 'contact_name'])) ? '/' : ''}
                  {order?.getIn(['tenant', 'contact_name'])}
                </div>
                <div className={styles.descitem}>
                  {order?.getIn(['tenant', 'owner', 'remark'])}
                  {(order?.getIn(['tenant', 'owner', 'remark']) && order?.getIn(['tenant', 'contact_tel'])) ? '/' : ''}
                  {order?.getIn(['tenant', 'contact_tel'])}
                </div>
              </div>
            </div>
            <div className={styles.infoitem}>
              <div className={styles.desclist}>
                <div className={styles.descitem}>
                  {/* <Badge count={conv?.get('unread_count')} offset={[7, 0]}  > */}
                  {order?.get('order_no')}
                  {/* </Badge> */}
                  {/* <div style={{ display: 'inline-block', marginLeft: 10 }}>

                  {order.get('fee')?.size !== 0 && !order.get('fee_locked') && (
                    <Tooltip title="待锁定">
                      <Tag
                        className={styles.convTag}
                        style={{
                          color: '#fff',
                          background: '#e84951',
                          borderColor: '#b40f0f',
                        }}
                      >
                        锁
                      </Tag>
                    </Tooltip>
                  )}
                  {timeout && (
                    <Tooltip title="超过两个小时未预约上门时间">
                      <Tag className={styles.convTag}>超</Tag>
                    </Tooltip>
                  )}
                  {order.get('prev_order') && (
                    <Tooltip title="再次上门">
                      <Tag className={styles.convTag} color="orange">
                        再次
                      </Tag>
                    </Tooltip>
                  )}
                </div> */}
                </div>
                <div className={styles.descitem}>
                  产品名称：{order?.getIn(['product_list', 0, 'name'])}
                </div>
              </div>
            </div>
          </div>
        }
      </div>
      <div className={styles.worker}>
        <div className={styles.workercontent}>
          <div className={styles.workericon}>
            <Icon type="user" />
          </div>
          <span>{order?.get('contact_name')}{order?.get('is_retail') ? '(散户)' : ''}</span>
          <span>{order?.get('contact_mobile')}</span>
          <span>{order?.get('address')}</span>
        </div>

        {order?.get('tip')?.size == 0 && <BottomRightMenu />}

      </div>
      {(order?.get('tip')?.size > 0 && order?.getIn(['tip', 0, 'message_type']) != 2) && <div className={styles.worker}>
        {order?.getIn(['tip', 0, 'type']) == 16 ? <div style={{
          display: 'flex', alignItems: 'center',
          justifyContent: 'center',
          marginRight: 10,
          height: 25
        }}>
          师傅报价数量 {order?.get('quotationNum') ? <BlinkingBadge count={order?.get('quotationNum')} style={{ transform: 'scale(0.8)', marginRight: 6 }} /> : 0}
        </div> : <>
          <div className={styles.workercontent}>

            <span>{order?.getIn(['tip', 0, 'role'])}</span>
            <span className={styles.color1}>{order?.getIn(['tip', 0, 'user', 'name'])}</span>
            {/* <span className={styles.color1}>{utils.tipType[order?.getIn(['tip', 0, 'type'])]}</span> */}
            <span>{order?.getIn(['tip', 0, 'message'])}</span>
            {(order?.getIn(['tip', 0, 'type']) == 5 ||
              order?.getIn(['tip', 0, 'type']) == 27) &&
              <span title={order?.getIn(['tip', 0, 'value']) || ''}>{order?.getIn(['tip', 0, 'value'])}</span>
            }
            {order?.getIn(['tip', 0, 'type']) == 14 && <span title={order?.get('tenant_refuse_fee_reason') || ''}>{order?.get('tenant_refuse_fee_reason')}</span>}

          </div>
        </>}
        <BottomRightMenu />
      </div>}

      {(order?.get('tip')?.size > 0 && order?.getIn(['tip', 0, 'message_type']) == 2) && <div className={styles.worker}>
        {order?.getIn(['tip', 0, 'type']) == 16 ? <div style={{
          display: 'flex', alignItems: 'center',
          justifyContent: 'center',
          marginRight: 10,
          height: 25
        }}>
          师傅报价数量 {order?.get('quotationNum') ? <BlinkingBadge count={order?.get('quotationNum')} style={{ transform: 'scale(0.8)', marginRight: 6 }} /> : 0}
        </div> : <>
          <div className={styles.workercontent}>

            {/* <span>{order?.getIn(['tip', 0, 'role'])}</span> */}
            {/* <span className={styles.color1}>{order?.getIn(['tip', 0, 'user', 'name'])}</span> */}
            {/* <span className={styles.color1}>{utils.tipType[order?.getIn(['tip', 0, 'type'])]}</span> */}
            <span>{order?.getIn(['tip', 0, 'message'])}</span>

          </div>
        </>}

        <BottomRightMenu />
      </div>}
      {/* {process.env.APP_MODE !== 'tenant' && conv?.get('is_pinned') && (
        <i className={cn('iconfont', styles.fixedTop)}>&#xe604;</i>
      )} */}
      {/* {!isTenantMode && order.get('active_state') === 1 && (
        <div className={styles.moreBtn}>
          <Dropdown overlay={menu} trigger={['click']}>
            <Icon type="more" />
          </Dropdown>
        </div>
      )} */}
    </div>
  );
}
const TenantConversationItem = Form.create()((props) => {
  const { convId, customConv, showConvFold, type, change, resetConvList, onViewChatRecords, resetTaskHall, form } = props
  const { getFieldDecorator, validateFields, getFieldValue, setFieldsValue, resetFields } = form;


  const dispatch = useDispatch();
  const conv = customConv || useSelector(getConvByIdSelector(convId));
  // const order = useSelector(orderOfConvSelector(convId), is);
  const order = useSelector(findById(conv?.get('order_id')))
  const isActive = useSelector(isActiveSelector(convId));
  const prevActiveState = usePrevious(isActive);

  const [isOpenConfirmFee, setIsOpenConfirmFee] = useState(false)
  const [confirmFeeType, setConfirmFeeType] = useState(1)

  const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },

  };

  const clickHandler = useCallback(() => {
    !isActive && dispatch(navToConversation(convId, order?.get('_id')));
    typeof change === 'function' && change({ convId, orderId: order?.get('_id') })
  }, [convId, order, isActive]);

  const ignoreOrders = (orderId) => {
    taskHallServices.setIgnore({
      source: 3,
      orderId: orderId,
    }).then(result => {
      typeof resetConvList == 'function' && resetConvList()
      message.success('操作成功')
    }).catch((err) => {
      message.error(err.message || '操作失败，请刷新重试');
    })
      .finally(() => {
      });
  }

  const togglePinnedHandler = useCallback(
    (event) => {
      event.preventDefault();
      dispatch(togglePinned(convId));
    },
    [convId]
  );
  const calTenantFee = (worker_fee_total, service_fee = 0) => {
    let total = 0;
    if (worker_fee_total) {
      total = worker_fee_total
    }
    if (isTenantMode) {
      total += service_fee
    }
    return total ? total.toFixed(2) : total
  };
  // 忽略订单
  // const ignoreOrders = (orderId) => {
  //   taskHallServices.setIgnore({
  //     orderId: orderId,
  //   }).then(result => {
  //     setSearchData()
  //     message.success('操作成功')
  //   }).catch((err) => {
  //     message.error(err.message || '操作失败，请刷新重试');
  //   })
  //     .finally(() => {
  //     });
  // }
  const handleAssignWorker = () => {
    // if (!order.get('addr_location')) {
    //   return message.warn('请先确认上门位置');
    // }
    dispatch(showAssignWorkerDialog({ title: '查看报价/指派师傅', id: order?.get('_id') }));
  }

  const openConfirmFeeModal = (type = 1) => {
    setConfirmFeeType(type)
    setIsOpenConfirmFee(true)
  }
  const closeConfirmFeeModal = () => {
    setConfirmFeeType(1)
    setIsOpenConfirmFee(false)
  }
  const handleSubmitConfirmFee = () => {
    validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }
      if (confirmFeeType == 1) {
        const params = {
          orderId: order?.get('_id'),
          tenant_confirm_fee: 1,
          tenant_refuse_fee_reason: ''
        }
        saveOrderConfirmFee(params).then(res => {
          resetConvList()
          closeConfirmFeeModal()
          message.success('操作成功');
        }).catch((err) => {
          message.error(err?.message || '提交失败');
        })
      } else if (confirmFeeType == 2) {
        const params = {
          orderId: order?.get('_id'),
          tenant_confirm_fee: 2,
          tenant_refuse_fee_reason: values.reason
        }
        saveOrderConfirmFee(params).then(res => {
          resetConvList()
          closeConfirmFeeModal()
          message.success('操作成功');
        }).catch((err) => {
          message.error(err?.message || '提交失败');
        })
      }

    });
  }
  const latest_ts = dayjs(conv?.get('latest_ts'));
  const latestTs = latest_ts.isSame(dayjs(), 'day')
    ? latest_ts.format('HH:mm')
    : latest_ts.fromNow();
  // const latestTs = latest_ts.format('HH:mm:ss')

  useUpdateEffect(() => {
    // 异步更新 当前order的信息
    if (isActive && prevActiveState !== isActive) {
      dispatch(getOrder(order?.get('_id')));
    }
  });

  useMount(() => {
    if (isActive) {
      dispatch(getOrder(order?.get('_id')));
    }
  });

  const timeout =
    order?.get('worker') &&
    !order?.get('service_time') &&
    order?.get('worker_assigned_at') &&
    new Date(order?.get('worker_assigned_at')).getTime() < twoHourAgo;

  // TODO: currentId有变化的时候需要将滚动条移植相应位置
  const status = utils.getStatus(order);

  const BottomRightMenu = () => {
    return (
      <div className={styles.bottomRightMenu} onClick={e => e.stopPropagation()}>

        {(order?.get('custom_lock_fee') && !!!order?.get('tenant_confirm_fee') && order?.getIn(['tip', 0, 'type']) == 13) && <>
          <Button type="primary" size="small"
            style={{ marginRight: '10px' }}
            onClick={() => { openConfirmFeeModal(1) }}
          >同意</Button>
          <Button type="primary" size="small"
            style={{ marginRight: '10px' }}
            onClick={() => { openConfirmFeeModal(2) }}
          >拒绝</Button>
        </>}

        {(showConvFold == false)
          &&
          (
            <Button type="primary" size="small"
              style={{ marginRight: '10px' }}
              onClick={() => {
                typeof onProcessedSuccess == 'function' && onProcessedSuccess()
                ignoreOrders(order?.get("_id"))
              }}
            >忽略</Button>
          )}

        {/* {(conv.getIn(['activeDeal', 'avatar']) && order.get('tip')?.size > 0) && <Popover placement="topRight" content={
          (
            <div>
              <span>{order?.getIn(['tip', 0, 'role'])}</span>
              <span style={{ color: '#FF731B', margin: '0 5px' }}>{order?.getIn(["tip", 0, 'user', 'name'])}</span>
              <span>{utils.tipType[order?.getIn(['tip', 0, 'type'])]}</span>
            </div>
          )}>
          <img src={conv.getIn(['activeDeal', 'avatar'])} style={{ width: '24px', height: '24px', borderRadius: '50%' }} />
        </Popover>} */}

        <Button type="link" size="small"
          style={{ marginLeft: '5px' }}
          onClick={() => {
            clickHandler()
            typeof onViewChatRecords === 'function' && onViewChatRecords()
          }}
        >查看聊天记录<Badge count={conv?.get('unread_count')} style={{ transform: 'scale(0.8)' }}></Badge>
        </Button>
      </div>
    )
  }

  return (
    <>
      <div className={cn(styles.tenantConversationItem,
        order?.get('order_tip_op') == 1 && styles.operate,
        order?.get('order_tip_op') == 2 && styles.notice,
        isActive && styles.active)}
        onClick={clickHandler}
      >
        {order?.get('order_tip_op') == 2 ? <div className={cn(styles.itemstatus, styles.blue)}
        >
          提醒消息
        </div> : <>
          {(order?.get('is_urgent')
            // || timeout
          ) && (<div className={styles.itemstatus}>
            {order?.get('is_urgent') ? '急单' : ''}
            {/* {timeout ? '超时' : ''} */}
          </div>)}
        </>}

        <div className={styles.workorder}>
          <div className={styles.tags}>
            <div style={{ marginBottom: 5 }}>
              <TagFlag itemId={conv?.get('_id')} flag={conv?.get('tag_flag')} change={() => {
                resetConvList()
                dispatch(getOrder(order?.get('_id')))
              }} />
            </div>
            <StatusBadge className={styles.tagitem} style={{ background: '#4D4D4D' }}>
              {latestTs}
            </StatusBadge>
            {Object.keys(status).length > 0 && <StatusBadge className={styles.tagitem} style={status.style}>
              {status.text}{(order?.get('is_guaqi') && [
                orderStatus.PROCESSING_WAIT_APPOINTMENT,
                orderStatus.PROCESSING_WAIT_SERVICE,
                orderStatus.WORKER_LOCATION_CHECKED,
              ].includes(order?.get('status_code'))) ? ' | 挂起' : ''}
            </StatusBadge>}
          </div>
          <div className={styles.workorderinfo} >
            <div className={styles.inforow}>
              <div className={styles.infobox}>
                <div className={styles.infoitem}>
                  {
                    order?.get('tenant') &&
                    (
                      <div className={styles.logo}>
                        {order?.getIn(['tenant', 'logo']) ? (
                          <Avatar
                            size={42}
                            src={order?.getIn(['tenant', 'logo'])}
                          />) :
                          (
                            <Avatar size={42}
                              style={{ backgroundColor: '#87d068' }}>
                              {simplifyLogoName(order?.getIn(['tenant', 'short_name']))}
                            </Avatar>
                          )
                        }
                        <div className={cn(styles.workstatus, order?.get('isActive') ? styles.active : '')}></div>
                      </div>
                    )
                  }
                  <div className={styles.desclist}>
                    <div className={styles.descitem}>
                      {order?.getIn(['tenant', 'short_name'])}
                      {(order?.getIn(['tenant', 'short_name']) && order?.getIn(['tenant', 'contact_name'])) ? '/' : ''}
                      {order?.getIn(['tenant', 'contact_name'])}
                    </div>
                    <div className={styles.descitem}>
                      {order?.getIn(['tenant', 'owner', 'remark'])}
                      {(order?.getIn(['tenant', 'owner', 'remark']) && order?.getIn(['tenant', 'contact_tel'])) ? '/' : ''}
                      {order?.getIn(['tenant', 'contact_tel'])}
                    </div>

                  </div>
                </div>
                <div className={styles.infoitem}>
                  <div className={styles.desclist}>
                    <div className={styles.descitem}>
                      {order?.get('order_no')}

                      {/* <div style={{ display: 'inline-block', marginLeft: 10 }}>

                        {order.get('fee')?.size !== 0 && !order.get('fee_locked') && (
                          <Tooltip title="待锁定">
                            <Tag
                              className={styles.convTag}
                              style={{
                                color: '#fff',
                                background: '#e84951',
                                borderColor: '#b40f0f',
                              }}
                            >
                              锁
                            </Tag>
                          </Tooltip>
                        )}
                        {timeout && (
                          <Tooltip title="超过两个小时未预约上门时间">
                            <Tag className={styles.convTag}>超</Tag>
                          </Tooltip>
                        )}
                        {order.get('prev_order') && (
                          <Tooltip title="再次上门">
                            <Tag className={styles.convTag} color="orange">
                              再次
                            </Tag>
                          </Tooltip>
                        )}
                      </div> */}
                    </div>
                    <div className={styles.descitem}>
                      产品名称：{order?.getIn(['product_list', 0, 'name'])}
                    </div>
                  </div>
                </div>
                <div className={styles.infoitem} style={{
                  flex: '1 0 230px', maxWidth: '230px', maxWidth: 'none'
                }}>
                  <div className={styles.desclist}>
                    <div className={styles.descitem}>
                      <div className={styles.workerinfo}>
                        <div className={styles.workericon}>
                          <Icon type="user" />
                        </div>
                        <span>{order?.get('contact_name')}</span>
                        <span>{order?.get('contact_mobile')}</span>
                      </div>
                    </div>
                    <div className={styles.descitem}>
                      {order?.get('address')}
                    </div>
                  </div>
                </div>
                {/* {order?.get('worker') && <div className={styles.infoitem}>
                  <div className={styles.logo}>
                    {order?.getIn(['worker', 'user', 'avatar']) ? (
                      <Avatar
                        size={42}
                        src={order?.getIn(['worker', 'user', 'avatar'])}
                      />) :
                      (
                        <Avatar size={42}
                          style={{ backgroundColor: '#87d068' }}>
                          {simplifyLogoName(order?.getIn(['worker', 'realname']))}
                        </Avatar>
                      )
                    }
                    <div className={cn(styles.workstatus, order?.get('isActive') ? styles.active : '')}></div>
                  </div>

                  <div className={styles.desclist}>
                    <div className={styles.descitem}>
                      {(order?.getIn(['worker', 'realname']) || '') + ' '}
                      {order?.getIn(['worker', 'user', 'mobile'])}
                    </div>
                    <div className={styles.descitem}>
                      {order?.getIn(['worker', 'isVeteran']) &&
                        <StatusBadge style={{ color: '#fff', background: '#177c48' }}>
                          老兵
                        </StatusBadge>
                      }
                      {order?.getIn(['worker', 'isMargin']) &&
                        <StatusBadge style={{ color: '#ffffff', background: '#339900' }}>
                          保证金
                        </StatusBadge>
                      }
                    </div>
                  </div>
                </div>} */}
              </div>
              <div className={styles.infoother}>
                {order?.getIn(['tenant', 'quotationStart']) > 0 &&
                  order?.getIn(['tenant', 'quotationEnd']) > 0 &&
                  <div className={styles.descitem}>
                    合作价：{order?.getIn(['tenant', 'quotationStart'])} - {order?.getIn(['tenant', 'quotationEnd'])}
                  </div>
                }
                <div className={styles.member} onClick={e => e.stopPropagation()}>
                  <Member tenant={order?.get('tenant')}>
                    <Icon type="team" />
                  </Member>
                </div>
              </div>
            </div>
            <div className={styles.inforow}>
              <div className={styles.infobox}>
                {order?.get('ticket_type') != 2 && order?.get("assignTo") && <div className={styles.infoitem}>
                  <div className={styles.logo}>
                    {order?.getIn(['assignTo', 'avatar']) ? (
                      <Avatar
                        size={42}
                        src={order?.getIn(['assignTo', 'avatar'])}
                      />) :
                      (
                        <Avatar size={42}
                          style={{ backgroundColor: '#87d068' }}>
                          {simplifyLogoName(order?.getIn(['assignTo', 'name']))}
                        </Avatar>
                      )
                    }
                    <div className={cn(styles.workstatus, order?.getIn(['assignTo', 'isActive']) ? styles.active : '')}></div>
                  </div>

                  <div className={styles.desclist}>
                    <div className={styles.descitem}>
                      {order?.getIn(['assignTo', 'name'])}
                    </div>
                    <div className={styles.descitem}>
                      {order?.getIn(['assignTo', 'mobile'])}
                    </div>
                  </div>
                </div>}

                {order?.get('ticket_type') == 2 && <div className={styles.infoitem}
                >
                  <div style={{
                    width: '100%', height: '20px', margin: '10px 10px',
                    textAlign: 'center', color: '#fff', background: '#CA4141',
                    cursor: 'pointer'
                  }}
                    onClick={() => { handleAssignWorker() }}
                  >指派师傅</div>
                </div>}

                {(order?.get('tip')?.size > 0 && order?.get('ticket_type') != 2) && <div className={styles.infoitem} style={{ maxWidth: 'none' }}>
                  <div className={styles.desclist}>
                    {/* {(order?.getIn(['tip', 0, 'type']) == 1 || order?.getIn(['tip', 0, 'type']) == 12 || order?.getIn(['tip', 0, 'type']) == 13) &&
                      <div className={styles.descitem}>
                        客服已改价，等待确认
                      </div>} */}
                    {(conv?.get('order')?.status_code == 4001) &&
                      <div className={styles.descitem}>
                        客服已指派师傅
                      </div>}
                    {(order?.getIn(['tip', 0, 'type']) != 1 && order?.getIn(['tip', 0, 'type']) != 12) &&
                      <div className={styles.descitem}>
                        <span>{order?.getIn(['tip', 0, 'role'])}</span>
                        <span style={{ color: '#FF731B', margin: '0 5px' }}>{order?.getIn(["tip", 0, 'user', 'name'])}</span>
                        <span>{order?.getIn(['tip', 0, 'message'])}</span>
                        {[3, 5].includes(order?.getIn(['tip', 0, 'type'])) && <span style={{ margin: '0 5px' }} title={order?.getIn(['tip', 0, 'value']) || ''}>{order?.getIn(['tip', 0, 'value']) || ''}</span>}
                        {order?.getIn(['tip', 0, 'type']) == 13 && <><span style={{ color: '#FF731B', margin: '0 5px' }}>{order?.getIn(['tip', 0, 'value']) || 0}</span>元</>}
                        {order?.getIn(['tip', 0, 'type']) == 27 && <><span style={{ margin: '0 5px' }}>{order?.getIn(['tip', 0, 'value']) || 0}</span></>}
                      </div>}
                  </div>
                </div>}

                {order?.get('ticket_type') == 2 && <div className={styles.infoitem} style={{ maxWidth: 'none' }}>
                  {order?.get('status_code') == orderStatus.WAIT_ASSIGN && <div className={styles.desclist}>
                    <div className={styles.descitem}>
                      已报价师傅数
                    </div>
                    <div className={styles.descitem}>
                      <span className={styles.color}>{order?.get('quotationNum') || 0}位 师傅已报价</span>
                    </div>
                  </div>}
                  <div className={styles.desclist}>
                    <div className={styles.descitem}>
                      {/* 企业员工-<span className={styles.color}>{order?.getIn(['tenantAssignTo', 'name'])}</span> */}
                      {/* 指派师傅 <span className={styles.color}>{order?.getIn(['worker', 'realname'])}</span> */}
                      <div className={styles.desclist}>
                        <div className={styles.descitem}>
                          {order?.getIn(['tip', 0, 'role']) == '商家' && <span>企业员工-</span>}
                          {order?.getIn(['tip', 0, 'role']) != '商家' && <span>{order?.getIn(['tip', 0, 'role'])}</span>}
                          <span style={{ color: '#FF731B', margin: '0 5px' }}>{order?.getIn(["tip", 0, 'user', 'name'])}</span>
                          <span>{order?.getIn(['tip', 0, 'message'])}</span>
                          <span style={{ margin: '0 5px' }} title={order?.getIn(['tip', 0, 'value']) || ''}>{order?.getIn(['tip', 0, 'value']) || ''}</span>
                        </div>
                      </div>
                    </div>
                    {order?.get('status_code') > orderStatus.WAIT_ASSIGN &&
                      <div className={styles.descitem}>
                        总计：<span className={styles.color}>{order?.get('fee_total') ? order?.get('fee_total')?.toFixed(2) : 0}</span>
                        {/* 总计：<span className={styles.color}>{calTenantFee(order.get('worker_fee_total'), order.get('worker_fee_service'))}</span> */}
                        （{order.get('worker_fee').map((item, index) => {
                          return <span key={index}>{`${item.get('name')}`}<span className={styles.color}>{Number(item.get('price')) ? Number(item.get('price'))?.toFixed(2) : 0}</span></span>
                        })} 含平台服务费<span className={styles.color}>{order.get('fee_service') ? order.get('fee_service')?.toFixed(2) : 0}</span>）
                      </div>}
                  </div>

                  {/* {order?.getIn(['tip', 0, 'type']) == 3 && <div className={styles.desclist}> */}
                  {/* {order?.get('status_code') >= orderStatus.PROCESSING_WAIT_APPOINTMENT  && <div className={styles.desclist}>
                    <div className={styles.descitem}>
                      <span>{order?.getIn(['tip', 0, 'role'])}</span>
                      <span style={{ color: '#FF731B', margin: '0 5px' }}>{order?.getIn(["tip", 0, 'user', 'name'])}</span>
                      <span>{order?.getIn(['tip', 0, 'message'])}</span>
                      <span style={{ margin: '0 5px' }} title={order?.getIn(['tip', 0, 'value']) || ''}>{order?.getIn(['tip', 0, 'value']) || ''}</span>
                    </div>
                  </div>} */}
                </div>}
              </div>
              <div className={styles.infoother}>
                <BottomRightMenu />
              </div>
            </div>
          </div>
        </div>
      </div >
      <Modal
        title="确认/拒绝保价"
        destroyOnClose
        width={confirmFeeType % 2 == 1 ? 350 : 520}
        visible={isOpenConfirmFee}
        onOk={() => { handleSubmitConfirmFee() }}
        onCancel={() => { closeConfirmFeeModal() }}

        mask={false}
      >
        <div>
          <Form
            {...formItemLayout}
          >
            {confirmFeeType == 1 && <div className={styles.orderNoticeTips}>
              <div className={styles.tipsiconbox}>

                <div className={styles.tipstext}>
                  点击【确定】后将同意保价。
                </div>
              </div>
            </div>}
            {confirmFeeType == 2 && <Form.Item
              label="拒绝原因"
            >
              {getFieldDecorator('reason', {
                rules: [
                  { required: true, message: `请输入拒绝原因`, }
                ],
              })(
                <Input.TextArea rows={4} placeholder={`请输入拒绝原因`} />
              )}
            </Form.Item>}
          </Form>
        </div>
      </Modal>
    </>
  );
})

function Conversations({ showConvFold, taskHallSelectOrderId, setTaskHallSelectOrderId, change, onViewChatRecords, resetTaskHall }, ref) {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const convIds = useSelector(getConvIdsSelector, is);

  const currentConvId = useSelector(currentConvIdSelector);
  const user = useSelector(getCurrentUser);
  const convRefreshKey = useSelector(convRefreshKeySelector);

  const id = user.getIn([APP_MODE, "_id"])

  const [currentChat, setCurrentChat] = useState(null)
  const [expandOrderId, setExpandOrderId] = useState(null)
  const [foldList, setFoldList] = useState([]);

  const [showSearchDialog, setShowSearchDialog] = useState(false);
  const [searchDialogList, setSearchDialogList] = useState([]);

  const [convSelectOrderId, setConvSelectOrderId] = useState('');

  const editorBoxRef = useRef(null)

  useImperativeHandle(ref, () => ({
    fetchList: (params = {}) => {
      initConvs(params)
    },
    chataaaa: (orderId, convId) => {
      console.log("expand11111")
      setCurrentChat(convId)
      setExpandOrderId(orderId)
    },
    searchData: (params = {}) => {
      setSearchData(params)
      setShowSearchDialog(true)
    }
  }));
  const setSearchData = (params = {}) => {
    if (Object.keys(params).length) {
      dispatch(taskFetched(params)); // 倒是可以更新列表，不浪费资源 😁
    }
    setSearchDialogList(params.data || [])
  }
  const showOrderCreator = useCallback((user, id) => {
    if (user.get('originTenant') === 0) {
      message.warning('请使用该子账号的员工账号创建订单')
      return false
    }
    dispatch(
      showCreateOrderDialog({
        title: '创建工单',
        user,
        dispatch
      })
    );
  }, []);
  const getFoldData = () => {

    taskHallServices.fetchTask({
      type: isTenantMode ? 4 : 2,
      // offset: offset,
      // limit: limit,
      is_fold: 1
    }).then(result => {
      if (Object.keys(result).length) {
        dispatch(taskFetched(result)); // 倒是可以更新列表，不浪费资源 😁
      }
      setFoldList(result.data);
    }).catch((err) => {
      message.error(err.message || '获取列表失败，请刷新重试');
    }).finally(() => { });
  }

  const initConvs = (params = {}) => {
    const payload = { ...params };
    payload.queryType = isTenantMode ? 4 : 2;
    if (location?.state?.order) {
      payload.orderId = location.state.order;
      history.replace(location.pathname); // delete old state
    } else {
      const prevActiveId = localStorage.getItem(
        `current_conv_item_${process.env.APP_MODE}`
      );
      payload.convId = prevActiveId;

      localStorage.removeItem(`current_conv_item_${process.env.APP_MODE}`); // clear cache
    }

    if (location?.state?.searchOrderNo && isManagerMode) {
      editorBoxRef.current?.searchData({
        keyword: location?.state?.searchOrderNo, callback: (data) => {
          let item = (data.data || [])[0] || {}
          if (item?._id && item?.order_id) {
            dispatch(navToConversation(item?._id, item?.order_id));
          }
        }
      })
      history.replace(location.pathname); // delete old state
    }

    dispatch(fetchConvs(payload));

    // if (isManagerMode) {
    //   dispatch(fetchGroupManager(payload));
    // }
    if (isTenantMode) {
      dispatch(fetchStaffConvs(payload));
    }
  }
  const refreshConvs = async () => {
    await dispatch(resetConvs())
    initConvs()
    if (showConvFold) {
      getFoldData()
    }
  }
  useEffect(() => {
    if (showConvFold) {
      getFoldData()
    }
  }, [showConvFold])

  useEffect(() => {
    if (convRefreshKey !== 'initkey') {
      refreshConvs()
    }
  }, [convRefreshKey])

  useMount(() => {
    initConvs()
  });

  return (
    <div className={styles.convviewwrap}>
      <div className={styles.convwrap}>
        {/* 正常工单列表 */}
        <div className={styles.convlist}>
          {convIds.map((item, index) => (
            <div key={index}>
              {isTenantMode ?
                <TenantConversationItem
                  key={index}
                  convId={item}
                  change={(params) => {
                    change(params)
                    setConvSelectOrderId(params.orderId)
                  }}
                  showConvFold={showConvFold}
                  resetConvList={() => { initConvs() }}
                  onViewChatRecords={onViewChatRecords}
                  resetTaskHall={resetTaskHall}
                />
                :
                <ConversationItem
                  key={index}
                  convId={item}
                  change={(params) => {
                    change(params)
                    setConvSelectOrderId(params.orderId)
                  }}
                  resetConvList={() => { initConvs() }}
                  onChat={(convId, orderId) => {
                    setCurrentChat(convId)
                    setExpandOrderId(orderId)
                  }} />
              }

            </div>
          ))}
          {convIds?.size == 0 && (
            <div className={styles.empty}>
              <img src={process.env.PUBLIC_URL + '/empty.svg'}></img>
              <div>
                {isTenantMode ? (
                  <>
                    <div className={styles.text}>
                      <div>您名下暂无工单， 赶紧去</div>
                      <Button
                        onClick={showOrderCreator.bind(this, user, id)}
                        type="primary"
                        size="small"
                        className={styles.createBtn}
                      >
                        创建
                      </Button>
                      <div>吧 ^_^</div>
                    </div>
                    <div style={{ color: '#b1b1b1', paddingTop: 10 }}>
                      <span>也可以去 </span>
                      <Link to={'/orders'}>历史工单</Link>
                      <span> 查看所有工单哦</span>
                    </div>
                  </>
                ) : (
                  <div>
                    <div>暂无需要关注的工单</div>
                    <p>
                      <span>赶紧去 </span>
                      <Link to={'/orders'}>历史工单</Link>
                      <span> 里认领一些工单吧 ^_^</span>
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        {/* 已处理工单、已接收工单 */}
        {showConvFold && <div className={styles.foldview}>
          {foldList.map((item, index) => (
            <div key={item._id}>
              {isTenantMode ?
                <TenantConversationItem
                  key={item._id}
                  convId={item._id}
                  customConv={Map(item)}
                  showConvFold={showConvFold}
                  change={(params) => {
                    change(params)
                    setConvSelectOrderId(params.orderId)
                  }}
                  resetConvList={() => { initConvs() }}
                  onViewChatRecords={onViewChatRecords}
                  resetTaskHall={resetTaskHall}
                />
                :
                <ConversationItem
                  type="processed"
                  key={item._id}
                  convId={item._id}
                  customConv={Map(item)}
                  change={(params) => {
                    change(params)
                    setConvSelectOrderId(params.orderId)
                  }}
                  resetConvList={() => { initConvs() }}
                  onChat={(convId, orderId) => {
                    setCurrentChat(convId)
                    setExpandOrderId(orderId)
                  }}
                />
              }

            </div>
          ))}
        </div>}

        {/* 展开聊天 */}
        {currentChat &&
          <div className={styles.chatviewwrap}>
            <ConversationItem
              type="chatview"
              convId={currentChat}
              change={(params) => {
                change(params)
                setConvSelectOrderId(params.orderId)
              }}
              onChat={(convId, orderId) => {
                setCurrentChat(convId)
                setExpandOrderId(orderId)
              }} />
            <div className={styles.chatview}>
              <MessageList
                orderId={expandOrderId}
                onChat={(convId, orderId) => {
                  setCurrentChat(convId)
                  setExpandOrderId(orderId)
                }}
                onEndConversation={({ orderId }) => {
                  closeMessageOrder({ convId: currentChat, orderId }).then(res => {
                    initConvs()
                  }).catch(err => {
                  })
                }}
              />
            </div>
          </div>
        }
      </div>
      {!isTenantMode && <div>
        <EditorBox
          convId={currentConvId}
          orderId={taskHallSelectOrderId || convSelectOrderId}
          onChangeSearchData={data => {
            setSearchData(data)
            setShowSearchDialog(true)
          }}
          ref={editorBoxRef}
        />
      </div>}
      <Modal
        title={(<>搜索结果<span style={{ fontSize: '14px', color: '#999', marginLeft: '10px' }}>共<span style={{ color: '#FF731B' }}>{searchDialogList.length}</span>条搜索结果</span></>)}
        destroyOnClose
        footer={null}
        width={500}
        maskClosable={false}
        visible={showSearchDialog}
        onCancel={() => {
          setSearchData()
          setShowSearchDialog(false)
        }}

        mask={false}
        wrapClassName={`middle-content-block-modal ${isManagerMode ? 'editor' : 'topsearch'}`}
        maskStyle={{ position: 'absolute' }}
        getContainer={() => document.getElementById('middle-content-block') || window}
      >
        <div className={styles.foldview}>
          {searchDialogList.map((item, index) => (
            <div key={item._id}>
              {isTenantMode ?
                <TenantConversationItem
                  key={item._id}
                  convId={item._id}
                  customConv={Map(item)}
                  showConvFold={showConvFold}
                  type="search"
                  change={(params) => {
                    change(params)
                    setConvSelectOrderId(params.orderId)
                  }}
                  resetConvList={() => { initConvs() }}
                  onViewChatRecords={onViewChatRecords}
                  resetTaskHall={resetTaskHall}
                />
                :
                <ConversationItem
                  key={item._id}
                  convId={item._id}
                  customConv={Map(item)}
                  type="search"
                  change={(params) => {
                    setTaskHallSelectOrderId('')
                    setConvSelectOrderId(params.orderId)
                    // typeof onViewChatRecords === 'function' && onViewChatRecords()
                  }}
                  resetConvList={() => { initConvs() }}
                  onChat={(convId, orderId) => {
                    setCurrentChat(convId)
                    setExpandOrderId(orderId)
                  }} />
              }

            </div>
          ))}
        </div>
      </Modal>
    </div>
  );
}
export default forwardRef(Conversations)